import { createSlice } from "@reduxjs/toolkit";
import { config } from 'store/baseConfig';

const initialState = {
    fontFamily: config.fontFamily,
    borderRadius: config.borderRadius,
};

export const customizationSlice = createSlice({
    name: 'customization',
    initialState,
    reducers: {
        setFontFamily: (state, action) => {
            state.fontFamily = action.payload;
        },
        setBorderRadius: (state, action) => {
            state.borderRadius = action.payload;
        }
    }
});

export const { setFontFamily, setBorderRadius } = customizationSlice.actions;

export default customizationSlice.reducer;